export default __webpack_public_path__ + "static/media/PER.9cdba94a.svg";